import styled from "styled-components"

const StyledHero = styled.div`
  padding: 170px 0 75px;
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;

  @media (max-width: 1010px) {
    padding: 95px 30px 30px;
  }

  @media (max-width: 575px) {
    align-items: flex-end;
    min-height: 90vh;
  }

  .home-hero {
    &__inner {
      position: relative;
      z-index: 2;
      width: 100%;

      .circle-arrow {
        background: none;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        border: 2px solid #fff;
        z-index: 2;
        transition: 0.2s;

        @media (max-width: 1440px) {
          display: none;
        }

        &.mobile {
          display: none;

          @media (max-width: 1010px) {
            display: flex;
          }
        }

        [stroke] {
          transition: 0.2s;
        }
        &:hover {
          border-color: #00fb6e;
          [stroke] {
            stroke: #00fb6e;
          }
        }
        &.prev {
          left: 35px;
          @media (max-width: 1440px) {
            left: 25px;
          }

          @media (max-width: 1010px) {
            left: 15px;
          }
        }
        &.next {
          right: 115px;

          @media (max-width: 1440px) {
            right: 85px;
          }

          @media (max-width: 1010px) {
            right: 15px;
          }
        }
      }
    }
    &__wrapper {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 155px;

      @media (max-width: 1010px) {
        flex-flow: wrap-reverse;
        justify-content: flex-start;
        padding-right: 0;
      }
    }
    &__header {
      flex-basis: 501px;
      max-width: 625px;

      @media (max-width: 1660px) {
        max-width: 485px;
        padding: 0 30px 0 0;
      }

      .title {
        line-height: 48px;
        line-height: 61px;
        /* color: #fff; */
        margin: 30px 0;
        @media (max-width: 1199px) {
          margin: 0 0 20px 0;
        }
      }
      img {
        margin-bottom: 55px;

        @media (max-width: 575px) {
          margin-bottom: 30px;
          max-height: 100px;
        }
      }
      .desc {
        font-size: 24px;
        line-height: 31px;
        margin-bottom: 50px;
        /* color: #fff; */
      }
      .header-button {
        padding: 18px;
        min-width: 280px;
        span {
          /* color: #fff; */
        }
      }
    }
    &__background-slider {
      position: absolute;
      background-color: #00fb6e;
      overflow: hidden;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        /* background-color: rgba(0, 0, 0, 0.17); */
        z-index: 1;
      }
      .slick-list {
        margin-right: -644px;
      }
      .slick-slider,
      .slick-list,
      .slick-track {
        height: 100%;
      }
      .slick-slide > div {
        height: 100%;
        margin-right: 644px;
        .slide-inner {
          height: 100%;
          width: 100vw;
          position: absolute;
          top: 0;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
        }
      }
    }

    &__image-claim {
      -webkit-animation: spin 10s linear infinite;
      -moz-animation: spin 10s linear infinite;
      animation: spin 10s linear infinite;

      /* @media (max-width: 575px) {
        position: absolute;
        top: 15px;
        left: 15px;
      } */

      img,
      svg {
        max-height: 250px;

        @media (max-width: 575px) {
          max-height: 150px;
        }
      }
    }

    @-moz-keyframes spin {
      100% {
        -moz-transform: rotate(360deg);
      }
    }
    @-webkit-keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
    @keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    &__image-slider {
      flex-basis: 441px;
      max-width: 441px;
      position: relative;

      .slider-overlay {
        background-color: #00fb6e;
        overflow: hidden;
      }

      .slick-list {
        margin-right: -300px;
      }

      .slick-slide > div {
        height: 100%;
        margin-right: 644px;
      }

      .slider-count {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        margin: 10px 0 0 0;

        @media (max-width: 1010px) {
          position: absolute;
          justify-content: center;
          bottom: -35px;
          left: 0;
          right: 0;
          margin: 0 auto;
        }

        span {
          display: inline-flex;
          width: 30px;
          height: 1px;
          background-color: #fff;
          margin: 0 10px;
        }
      }

      .slick-slide > div {
        .slide-inner {
          height: 515px;
          min-width: 441px !important;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          margin-bottom: -7px;
          position: relative;

          @media (max-width: 600px) {
            &:after {
              content: "";
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background-color: rgba(0, 0, 0, 0.15);
            }
          }

          @media (max-width: 600px) {
            height: 335px;
          }
        }
      }

      /* &::after {
        content: "";
        display: block;
        position: absolute;
        width: 111px;
        height: 111px;
        background-image: url("data:image/svg+xml;base64,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");
        background-size: 111px 111px;
        z-index: 1;
        bottom: 60px;
        left: -70px;
      } */
    }
  }
  /* @media screen and (max-width: 1550px) {
    padding: 50px 0 40px;
    .home-hero {
      &__wrapper {
        padding-right: 118px;
        align-items: flex-end;
      }
      &__header {
        flex-basis: 414px;
        max-width: 414px;
        .title {
          font-size: 48px;
          line-height: 51px;
          margin-bottom: 15px;
        }
        .desc {
          font-size: 24px;
          line-height: 31px;
          margin-bottom: 60px;
          color: #fff;
        }
        .header-button {
          padding: 15px;
          min-width: 200px;
          span {
            color: #fff;
          }
        }
      }
      &__image-slider {
        flex-basis: 303px;
        max-width: 303px;
        max-height: 400px;
        img {
          max-height: 400px;
        }
        &::after {
          bottom: -50px;
        }
      }
    }
  } */
  @media screen and (max-width: 1010px) {
    .home-hero {
      &__header {
        flex-basis: 500px;
        max-width: 500px;
        text-align: center;
        position: relative;
        z-index: 2;
        padding: 0;
        margin-top: 30px;
        .title {
          line-height: 58px;
          margin-bottom: 15px;
        }

        .desc {
          line-height: 32px;
          margin-bottom: 20px;
        }
        .header-button {
          padding: 15px;
          min-width: 340px;
        }
      }
      &__image-slider {
        &::after {
          display: none;
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    padding: 125px 0 30px;
    .home-hero {
      &__header {
        max-width: 100%;
        .title {
          font-size: 40px;
          line-height: 46px;
          margin-bottom: 15px;
        }
        .desc {
          font-size: 18px;
          line-height: 26px;
          margin-bottom: 28px;
        }
        .header-button {
          padding: 15px;
          min-width: 100%;
        }
      }
      &__image-slider {
        /* flex-basis: 214px;
        max-width: 214px;
        max-height: 318px; */
        flex-basis: 321px;
        max-width: 321px;
      }
    }
  }
`

export default StyledHero
